<div class="modal-body text-center">
    <p>{{ title }}</p>
    <div class="d-flex">
        <button type="button" class="btn btn-outline-primary mr-1 flex-fill" (click)="accept()">
            Aceptar
        </button>
    </div>
</div>